<template>
    <svg width="227" height="220" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path ref="p0"
            d="M226.975 218.215C195.51 198.677 135.28 166.4 111.388 138.573C103.816 153.367 91.1199 164.639 74.1755 174.396C34.8385 200.756 10.3216 213.471 0.0249917 220V143.904C0.0249917 134.416 2.44919 130.283 9.39689 126.738C33.6139 112.824 69.9269 93.2867 88.3708 77.0012V74.3359C55.9815 74.3359 26.3413 74.6293 0 75.5096V0C33.289 0.880293 65.3534 1.17372 113.487 1.17372C161.622 1.17372 194.586 0.880293 226.975 0V75.5096C197.61 74.3359 160.997 74.3359 123.484 74.3359V75.8275C134.68 84.1169 146.776 92.4064 158.598 99.8155C187.963 117.275 210.655 127.349 227 134.758V218.264L226.975 218.215Z"
            fill="black" fill-opacity="0.12" />
        <path ref="p1"
            d="M309.975 218.215C278.51 198.677 218.28 166.4 194.388 138.573C186.816 153.367 174.12 164.639 157.175 174.396C117.838 200.756 93.3216 213.471 83.025 220V143.904C83.025 134.416 85.4492 130.283 92.3969 126.738C116.614 112.824 152.927 93.2867 171.371 77.0012V74.3359C138.981 74.3359 109.341 74.6293 83 75.5096V0C116.289 0.880293 148.353 1.17372 196.487 1.17372C244.622 1.17372 277.586 0.880293 309.975 0V75.5096C280.61 74.3359 243.997 74.3359 206.484 74.3359V75.8275C217.68 84.1169 229.776 92.4064 241.598 99.8155C270.963 117.275 293.655 127.349 310 134.758V218.264L309.975 218.215Z"
            fill="black" fill-opacity="0.06" />
        <path ref="p2"
            d="M392.975 218.215C361.51 198.677 301.28 166.4 277.388 138.573C269.816 153.367 257.12 164.639 240.175 174.396C200.838 200.756 176.322 213.471 166.025 220V143.904C166.025 134.416 168.449 130.283 175.397 126.738C199.614 112.824 235.927 93.2867 254.371 77.0012V74.3359C221.981 74.3359 192.341 74.6293 166 75.5096V0C199.289 0.880293 231.353 1.17372 279.487 1.17372C327.622 1.17372 360.586 0.880293 392.975 0V75.5096C363.61 74.3359 326.997 74.3359 289.484 74.3359V75.8275C300.68 84.1169 312.776 92.4064 324.598 99.8155C353.963 117.275 376.655 127.349 393 134.758V218.264L392.975 218.215Z"
            fill="black" fill-opacity="0.04" />
        <path ref="p3"
            d="M475.975 218.215C444.51 198.677 384.28 166.4 360.388 138.573C352.816 153.367 340.12 164.639 323.175 174.396C283.838 200.756 259.322 213.471 249.025 220V143.904C249.025 134.416 251.449 130.283 258.397 126.738C282.614 112.824 318.927 93.2867 337.371 77.0012V74.3359C304.981 74.3359 275.341 74.6293 249 75.5096V0C282.289 0.880293 314.353 1.17372 362.487 1.17372C410.622 1.17372 443.586 0.880293 475.975 0V75.5096C446.61 74.3359 409.997 74.3359 372.484 74.3359V75.8275C383.68 84.1169 395.776 92.4064 407.598 99.8155C436.963 117.275 459.655 127.349 476 134.758V218.264L475.975 218.215Z"
            fill="black" fill-opacity="0.02" />
    </svg>
    



</template>

<script setup lang="ts">
const p0 = ref<SVGPathElement | null>(null)
const p1 = ref<SVGPathElement | null>(null)
const p2 = ref<SVGPathElement | null>(null)
const p3 = ref<SVGPathElement | null>(null)
onMounted(async () => {
    if (process.client) {
        /*const gsap = (await import('gsap')).default
        gsap.to(p1.value, { x: 80, duration: .4,  delay: 0.2 })
        gsap.to(p2.value, { x: 160, duration: .8,  delay: 0.2 })
        gsap.to(p3.value, { x: 240, duration: 1.2,  delay: 0.2 })*/
    }
})

</script>

<style scoped>
svg {
    overflow: visible;

}
</style>